import { Map } from "immutable"
import * as React from "react"
import { AsyncState, IOWidget, Updater, fromJSX } from 'widgets-for-react'
import { CMSState, ImageSize } from '../../../../cms/blocks/types.gen'
import { ModernImageContainer } from "../../../../cms/blocks/widgets/ImageContainer.gen"
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types.ext.gen"


export type developmentBlockProps = {
  title: string
  images: Immutable.List<ParsedMediaImage>,
  image_size?: ImageSize
  get_default_data_src:(() => ImageSize)
  get_default_data_srcset:(() => [ImageSize, string][])
}

export type developmentBlockStyle = {
}


export function developmentBlock(
  props: developmentBlockProps,
  options?: { style?: developmentBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return cmsState =>fromJSX(() => DevelopmentBlockLayout(props,cmsState))
}

export const DevelopmentBlockLayout = (props: developmentBlockProps, cmsState: CMSState) => {
  return <section className="block block--development ls-block-spacing">
    <div className="block__inner ls-container">
      {props.title && 
        <header className="block__header">
          <h2 className="block__title title--m">{props.title}</h2>
        </header>
      }
      <div className="block__content">
        <ul className="block__list">
          {props.images.map((image) => 
            <li key={image.id} className="block__item item">
              {
                ModernImageContainer(
                    cmsState.images.get(image.field_media_image.image.id),
                    "item__icon",
                    image.field_media_image.alt,
                    props.get_default_data_src,
                    props.get_default_data_srcset,
                    '145px',
                    true,
                    '145',
                    '145'
                  ).run(_ => { })
              }
            </li>).toArray()
          }
        </ul>
      </div>
    </div>
  </section>
}